import ErrorComponent from './Error.vue'
import { createVNode, render } from 'vue'

const container = document.createElement('div')
container.style.zIndex = 1
const vn = createVNode(ErrorComponent)
render(vn, container)
document.body.appendChild(container)

const error = (title, content) => {
    vn.component.proxy.show(title, content);
} 

const confirm = {
    install(app) {
        app.config.globalProperties.$logError = error
    }
}

export default confirm